/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs'

const $nsid = 'chat.bsky.convo.sendMessage'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  convoId: /*#__PURE__*/ l.string(),
  message: /*#__PURE__*/ l.ref<ConvoDefs.MessageInput>(
    (() => ConvoDefs.messageInput) as any,
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<ConvoDefs.MessageView>(
    (() => ConvoDefs.messageView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Sends a message to a conversation. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'ConvoLocked',
  'InvalidConvo',
  'ReplyTargetNotFound',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
